import Collapsible from "../common/Collapsible"
import { PresentationModeToggle } from "../navigation/PresentationModePersonalSettings"

type Props = {
    value: boolean;
    onChange: (checked: boolean) => void
}

export const UserPersonalSettingsSection = (props: Props) => {
    return <Collapsible iconName="Contact" title="Personal Settings">
        <PresentationModeToggle
            value={props.value}
            onChange={props.onChange} />
    </Collapsible>
}